import { status } from '@/lib/plugins/authorization'
import axios from '@/lib/axios'
import store from '@/store'
import router from '@/router'
import { jwtPayload } from '@/lib/utils'

export async function signIn(username, password) {
  const un = username.toLowerCase()
  try {
    let resp = await axios({ auth: false }).post('/api/login', {
      username: un,
      password: password,
    })

    // If user's password is expired, reroute them to the UpdatePassword view.
    // Return before fetching account info; this will prevent authorized navigation
    // before the password is updated. 
    if(resp['data'] && resp['data']['password_expired'] === true) {
      store.dispatch('account/retrieveUserData', { username: un })
      router.push({ 
        name: 'update_password',
        query: { redirect: 'update_password' }
      })
      return
    }

    if (resp['data']) storeTokens(resp.data)
    store.dispatch('account/retrieveInfo')
    if (status() === 'active') {
      axios({ loaderDelay: 5000 }).post('/api/misc/record_login') // Record successful login
    } else {
      signOut()
      throw {
        response: resp,
      }
    }
  } catch (err) {
    if (err.response && err.response.status === 462) {
      const resp = await axios({ auth: false }).get('/api/get_user_data', {
          params: {
            username: un,
          }
        })
      router.push({
        name: 'complete_signup',
        params: { oldPassword: password, username, resp},
      })
    }
    throw err
  }
}
export function signOut() {
  localStorage.clear()
}

// Get the current token and calculate how much time is left.
// If there is less than five minutes left, refresh the token.
export function refreshToken() {
  const token = localStorage.getItem('idToken')
  if (!token) return
  const mainToken = jwtPayload(token)
  const diff = (mainToken.exp - Date.now() / 1000) / 60 // Minutes left on token
  if (diff < 30 && diff > 0) {
    axios({ auth: false })
      .post('/api/refresh', { token })
      .then(resp => storeTokens(resp.data))
  }
}

function storeTokens(session) {
  localStorage.setItem('idToken', session.token)
  localStorage.setItem('refreshToken', session.refresh)
}
